import { Card, Box } from "@mui/material";
import { TextVariant } from "@/core/components/Field/Text";
import { HeadingLevel } from "@/core/types/types";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";
import Image from "next/image";

const AlreadySignedMessage = ({ fullName }: { fullName: string }) => (
  <Card
    sx={{
      px: 2,
      py: 1,
      boxShadow: "none",
      mb: 3,
    }}
  >
    <Box mx={1}>
      <Box>
        <TextVariant text={fullName} variant={HeadingLevel.H3} />
      </Box>
      <Box display="flex" alignSelf="center" mt={2} gap={1}>
        <Image
          src="images/icons/checkmark.svg"
          width="20"
          height="20"
          alt="checkmark"
        />
        {t("additionalPassengerSignatures.alreadySigned")}
      </Box>
    </Box>
  </Card>
);

export { AlreadySignedMessage };
